import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import MakeCategoryButton from "./MakeCategoryButton";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";

import ItemsSkeleton from "../../../components/loaders/ItemsSkeleton";
import ListFilters from "../lists/filters/ListFilters";
import {useTranslation} from "react-i18next";
import CategoryCard from "./components/CategoryCard";
import {useNavigate} from "react-router-dom";
import {Pagination} from "@mui/lab";
import CategoriesOrderButton from "./orders/CategoriesOrderButton";
import Title from "../../../components/elements/Title";
import {scrollTop} from "../../../../config/values";

function CategoriesPage(){
    const { t } = useTranslation();
    const [items, setItems] = useState([]);
    const [filters, setFilters] = useState({});
    const [pages, setPages] = useState(1);
    const [current_page, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const navigation = useNavigate();

    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        let url = `${defaultVariables.url}/categories/get-all?page=${current_page}${!!filters.text ? "&search="+filters.text : ""}${!!filters.industry ? "&industry="+filters.industry : ""}`;
        axios.get(url,config)
            .then(response => {
                setItems(response.data.data);
                setPages(response.data.last_page);
                setCurrentPage(response.data.current_page);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }

    useEffect(() => {
        scrollTop();
        loadData();
    },[current_page]);

    useEffect(() => {
        scrollTop();
        loadData();
    },[filters]);

    const handleChange = (event, value) => {
        setCurrentPage(value);
    };
    const handleFilter = (filters) => {
        setFilters(filters);
    }
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('manageCategories')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{t('manageCategories')}</Title>
                </Grid>
                {
                    !!loading ?
                        <ItemsSkeleton xs={12} md={12} lg={12}/>
                        :
                        <>
                            <Grid item size={12}>
                                <ListFilters
                                    filters={['search','industries']}
                                    onFilter={handleFilter}
                                />
                            </Grid>
                            <Grid item size={12} style={{display:'flex',alignItems:"center",gap:8}}>
                                <MakeCategoryButton industry_id={filters?.industry} reload={() => loadData()}/>
                                <CategoriesOrderButton
                                    reload={() => loadData()}
                                    industry_id={filters?.industry}
                                />

                            </Grid>
                            <Grid item size={12} >
                                <Grid container spacing={2} justify="center" className="cats-manage-holder">
                                    {
                                        items.map((item,index) =>(
                                            <Grid item size={{xs:12}} key={index}>
                                                <CategoryCard item={item} reload={() => loadData()}/>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </Grid>
                            {
                                pages > 1 &&
                                <Grid item size={12}>
                                    <Pagination
                                        shape="rounded"
                                        count={pages}
                                        page={current_page}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            }

                        </>
                }
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(CategoriesPage);
